import BigNumber from 'bignumber.js'

import { BigNumber as BigNumber_, Order } from '@blade/std-lib'
import { DelugeId } from '@root/entities/user-short'

import type { UserApi } from '@root/shared/api'

export type Referee = {
  id: DelugeId
  firstName: string
  lastName: string
  username: string
  referralDate: Date
  tradingProfitUsd: BigNumber
}

export const fromDto = (dto: UserApi.ReferralDto): Referee => {
  return {
    id: DelugeId(dto.delugeId),
    firstName: dto.firstName,
    lastName: dto.lastName,
    username: dto.username,
    referralDate: new Date(dto.referredDate),
    tradingProfitUsd: BigNumber(dto.tradingProfitUSD),
  }
}

const getTradingProfit = (ref: Referee) => ref.tradingProfitUsd

export const cmpByProfitAsc = Order.mapInput(BigNumber_.order, getTradingProfit)
export const cmpByProfitDesc = Order.flip(cmpByProfitAsc)

export const fullName = (user: Referee) =>
  [user.firstName, user.lastName].filter(Boolean).join(' ')

export const displayName = (user: Referee) => {
  const fn = fullName(user)
  return fn || user.username
}

export const initials = (user: Referee) =>
  [user.firstName[0], user.lastName[0]].filter(Boolean).join('').toUpperCase()
